import React, { useEffect, useRef, useState } from 'react';
const MAX_CHARS = 300;
export function ReviewForm() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const panelRef = useRef<HTMLDivElement | null>(null);
  const [maxHeight, setMaxHeight] = useState('0px');
  useEffect(() => {
    const el = panelRef.current;
    if (!el) return;
    setMaxHeight(open ? `${el.scrollHeight}px` : '0px');
  }, [open, submitted, comment, rating]);
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitted(true);
  };
  const inputClass = 'w-full rounded-xl border border-gold/25 bg-night px-4 py-3 font-sans text-[16px] text-ivory placeholder:text-ivory/35 focus:border-gold focus:outline-none';
  return <div className="mt-10 overflow-hidden rounded-2xl border border-gold/60 bg-gold/[0.06]" data-id="element-103" data-mp="3b3r5wx1cmeiu">
      <button type="button" aria-expanded={open} aria-controls="review-form-panel" onClick={() => setOpen(v => !v)} className="flex w-full min-h-[56px] items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-104" data-mp="3h61fzfl5vlzh">
        <span className="flex-1 text-center font-display text-[17px] font-bold text-gold" data-id="element-105" data-mp="3qx4dy8isnkuj">
          ⭐ ¿Ya lo tenés? Dejá tu reseña
        </span>
        <svg aria-hidden="true" viewBox="0 0 24 24" className={`h-5 w-5 shrink-0 text-gold transition-transform duration-300 ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-106" data-mp="2y86vo5el1o1s">
          <path d="m6 9 6 6 6-6" data-id="element-107" data-mp="384jrb8toubz6" />
        </svg>
      </button>

      <div id="review-form-panel" ref={panelRef} className="accordion-panel" style={{
      maxHeight
    }} data-id="element-108" data-mp="3d5hi29srkeca">
        <div className="px-5 pb-6 pt-1" data-id="element-109" data-mp="neuc2up2oo5y">
          {submitted ? <p role="status" className="rounded-xl border border-gold/40 bg-gold/10 px-4 py-4 text-center font-sans text-[15px] text-gold" data-id="element-110" data-mp="ni8hycwy3fi5">
              ¡Gracias! Tu reseña será publicada pronto.
            </p> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-111" data-mp="2jj0qnd6h3he2">
              <div data-id="element-112" data-mp="2jiio5yt7w6xp">
                <label htmlFor="review-name" className="mb-1.5 block font-sans text-[14px] text-ivory/70" data-id="element-113" data-mp="2jleild5uwdhe">
                  Nombre
                </label>
                <input id="review-name" type="text" required value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" className={inputClass} data-id="element-114" data-mp="2ti9d7kz0dtqe" />
              </div>

              <div data-id="element-115" data-mp="20tbytsxx4h2x">
                <label htmlFor="review-city" className="mb-1.5 block font-sans text-[14px] text-ivory/70" data-id="element-116" data-mp="20tu1p8f35tjt">
                  Ciudad
                </label>
                <input id="review-city" type="text" required value={city} onChange={e => setCity(e.target.value)} placeholder="Tu ciudad" className={inputClass} data-id="element-117" data-mp="29th5u1z79dgk" />
              </div>

              <fieldset data-id="element-118" data-mp="1m1a4spij4iat">
                <legend className="mb-1.5 font-sans text-[14px] text-ivory/70" data-id="element-119" data-mp="1i2ks6z5bf4s8">
                  Tu puntuación
                </legend>
                <div className="flex items-center gap-2" data-id="element-120" data-mp="17wjjckl66cso">
                  {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" aria-label={`${star} estrella${star > 1 ? 's' : ''}`} aria-pressed={rating === star} onClick={() => setRating(star)} className="p-1 transition-transform active:scale-90" data-id="element-121" data-mp="1cpw3oiitfxfm">
                      <svg aria-hidden="true" width="30" height="30" viewBox="0 0 24 24" fill={star <= rating ? '#3E6B3B' : 'none'} stroke={star <= rating ? '#3E6B3B' : 'rgba(62,107,59,0.55)'} strokeWidth="1.8" data-id="element-122" data-mp="12zay2b4q5sn7">
                        <path d="M12 2.5l2.9 5.9 6.6.9-4.8 4.6 1.2 6.5L12 17.3l-5.9 3.1 1.2-6.5L2.5 9.3l6.6-.9L12 2.5z" data-id="element-123" data-mp="1vlm78a6ed1vm" />
                      </svg>
                    </button>)}
                </div>
              </fieldset>

              <div data-id="element-124" data-mp="5bj0vh5o2rfm">
                <label htmlFor="review-comment" className="mb-1.5 block font-sans text-[14px] text-ivory/70" data-id="element-125" data-mp="5azrwpxzvddq">
                  Comentario
                </label>
                <textarea id="review-comment" required rows={4} maxLength={MAX_CHARS} value={comment} onChange={e => setComment(e.target.value)} placeholder="Contanos tu experiencia con el libro" className={`${inputClass} resize-none`} data-id="element-126" data-mp="a7zrci0c9hvv" />
                <p className="mt-1 text-right font-sans text-[13px] text-ivory/40" data-id="element-127" data-mp="gqvz4tjwcy9s">
                  {comment.length}/{MAX_CHARS}
                </p>
              </div>

              <button type="submit" className="w-full min-h-[56px] rounded-[14px] border border-gold bg-transparent px-5 py-4 font-sans text-[16px] font-bold text-gold
                  transition-all duration-150 active:scale-[0.97] hover:bg-gold/10" data-id="element-128" data-mp="19g2zly2wvxxo">
                Publicar Reseña
              </button>
            </form>}
        </div>
      </div>
    </div>;
}